import { defineMessages } from 'react-intl';

export default defineMessages({

    fnolClaimInfoHeader1: {
        id: 'portal.views.fnolClaimInfoHeader1',
        defaultMessage: 'During regular business hours'
    },
    fnolClaimInfoText1: {
        id: 'portal.views.fnolClaimInfoText1',
        defaultMessage: 'Please contact your broker or agent first. They will be able to help you in submitting the claim to us and provide us with all of the relavant information needed to submit your claim.'
    },
    fnolClaimInfoHeader2: {
        id: 'portal.views.fnolClaimInfoHeader2',
        defaultMessage: 'After hours claims service'
    },
    fnolClaimInfoTextAll: {
        id: 'portal.views.fnolClaimInfoTextAll',
        defaultMessage: 'Please contact Sedgwick Canada Inc. at 1-800-ADJUST4 who are trained to handle all of your immediate claims concerns. If possible have your policy number ready so that an adjuster can quickly access your policy information.'
    },
    fnolClaimInfoText2: {
        id: 'portal.views.fnolClaimInfoText2',
        defaultMessage: 'Have your policy number and broker name ready, as well as any relevant details. Once Heartland has been advised of a claim, an adjuster will contact you as soon as possible. '
            + 'For an after-hours emergency, call our 24-hour response line'

    },
    fnolClaimInfoText3: {
        id: 'portal.views.fnolClaimInfoText3',
        defaultMessage: ' who are trained to handle all of your immediate claims concerns. If possible have your policy number ready so that an adjuster can quickly access your policy information.'
    }

});
